<template>
  <div class="recharge_left capital_first">
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span class="title">交易查询</span>
      </div>
      <el-tabs v-model="activeName"  stretch>
        <el-tab-pane label="持仓查询" name="all_depot">
          <el-table
            :data="all_depot"
            stripe
            size="mini"
            style="width: 100%">
            <el-table-column
              prop="name"
              align="center"
              label="名称">
            </el-table-column>
            <el-table-column
              prop="short"
              align="center"
              label="代码">
            </el-table-column>
            <el-table-column
              prop="number"
              align="center"
              label="总持仓数">
            </el-table-column>
            <el-table-column
              prop="surplus"
              align="center"
              label="可卖数量">
            </el-table-column>
            <el-table-column
              prop="frozen"
              align="center"
              label="冻结数量">
            </el-table-column>
            <el-table-column
              prop="newPrice"
              align="center"
              label="当前价">
            </el-table-column>
            <el-table-column
              prop="price"
              align="center"
              label="成本价">
            </el-table-column>
            <el-table-column
              prop="profitPrice"
              align="center"
              label="盈亏金额">
            </el-table-column>
            <el-table-column
              prop="priceRatio"
              align="center"
              label="盈亏比例">
              <template slot-scope="scope">
                <p>{{ scope.row.priceRatio }}%</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="market"
              align="center"
              label="持仓市值">
            </el-table-column>
            <el-table-column
              prop="time"
              align="center"
              label="开仓日">
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="撤单查询" name="all_cancel">
          <el-table
            :data="all_cancel"
            size="mini"
            stripe
            style="width: 100%">
            <el-table-column
              prop="name"
              align="center"
              label="名称">
            </el-table-column>
            <el-table-column
              prop="short"
              align="center"
              label="代码">
            </el-table-column>
            <el-table-column
              prop="type"
              align="center"
              label="委托方向">
            </el-table-column>
            <el-table-column
            prop="deal"
            align="center"
            label="委托价格">
              <template slot-scope="scope">
                <p>{{ scope.row.deal.toFixed(2) }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="number"
              align="center"
              label="委托数量">
            </el-table-column>
            <el-table-column
              prop="surplus"
              align="center"
              label="未成交数量">
            </el-table-column>
            <el-table-column
              prop="status"
              align="center"
              label="委托状态">
            </el-table-column>
            <el-table-column
              prop="time"
              align="center"
              label="委托时间">
            </el-table-column>
            <el-table-column
              label="操作"
              align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.row)">撤单</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="委托查询" name="entrust">
        <el-form :inline="true" size="mini">
          <el-form-item label="委托日期">
            <el-date-picker
              v-model="entrustData.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getEntrust">查询</el-button>
          </el-form-item>

        </el-form>
        <el-table
          :data="entrustData.entrust"
          size="mini"
          stripe
          style="width: 100%">
          <el-table-column
            prop="name"
            align="center"
            label="名称">
          </el-table-column>
          <el-table-column
            prop="short"
            align="center"
            label="代码">
          </el-table-column>
          <el-table-column
            prop="deal"
            align="center"
            label="委托价格">
          </el-table-column>
          <el-table-column
            prop="price"
            align="center"
            label="成交价格">
          </el-table-column>
          <el-table-column
            prop="number"
            align="center"
            label="委托数量">
          </el-table-column>
          <el-table-column
            prop="finish"
            align="center"
            label="成交数量">
          </el-table-column>
          <el-table-column
            prop="type"
            align="center"
            label="买卖">
          </el-table-column>
          <el-table-column
            prop="status"
            align="center"
            label="状态">
          </el-table-column>
          <el-table-column
            prop="accurate"
            align="center"
            width="150"
            label="委托时间">
            <template slot-scope="scope">
              <p>{{ scope.row.time }} {{ scope.row.accurate }}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="complete_time"
            align="center"
            width="150"
            label="成交时间">
          </el-table-column>
        </el-table>
        <div class="changePage">
          <el-button type="primary" icon="el-icon-arrow-left" @click="prevEntrust" size="mini">上一页</el-button>
          <el-button type="primary" icon="el-icon-arrow-right" @click="nextEntrust" size="mini" style="float: right">下一页</el-button>
        </div>

      </el-tab-pane>
        <el-tab-pane label="成交查询" name="deal">
          <el-form :inline="true" size="mini">
            <el-form-item label="委托日期">
              <el-date-picker
                v-model="dealData.date"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getDeal">查询</el-button>
            </el-form-item>
            <el-form-item>
              买入额¥:{{ totalbuy.toFixed(2) }}
            </el-form-item>
            <el-form-item>
              卖出额¥:{{ totalsell.toFixed(2) }}
            </el-form-item>
          </el-form>
          <el-table
            :data="dealData.deal"
            size="mini"
            stripe
            style="width: 100%">
            <el-table-column
              prop="name"
              align="center"
              label="名称">
            </el-table-column>
            <el-table-column
              prop="code"
              align="center"
              label="代码">
            </el-table-column>
            <el-table-column
              prop="type"
              align="center"
              label="交易方向">
            </el-table-column>
            <el-table-column
              prop="price"
              align="center"
              label="成交价格">
            </el-table-column>
            <el-table-column
              prop="number"
              align="center"
              label="成交数量">
            </el-table-column>
            <el-table-column
              prop="total"
              align="center"
              label="成交金额">
            </el-table-column>
            <el-table-column
              prop="commission"
              align="center"
              label="券商佣金">
            </el-table-column>
            <el-table-column
              prop="stamp"
              align="center"
              label="印花税">
            </el-table-column>
            <el-table-column
              prop="change"
              align="center"
              label="过户费">
            </el-table-column>
            <el-table-column
              prop="extra_fee1"
              align="center"
              label="产品处理费">
            </el-table-column>
            <el-table-column
              prop="extra_fee2"
              align="center"
              label="结算费用">
            </el-table-column>
            <el-table-column
              prop="extra_fee3"
              align="center"
              label="平台费用">
            </el-table-column>
            <el-table-column
              prop="time"
              align="center"
              label="成交时间"
              width="100">
              <template slot-scope="scope">
                <p>{{ scope.row.time }}</p>
                <p>{{ scope.row.accurate }}</p>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="系统平仓" name="unwind">
          <el-table
            :data="unwindData"
            size="mini"
            stripe
            style="width: 100%">
            <el-table-column
              prop="name"
              align="center"
              label="名称">
            </el-table-column>
            <el-table-column
              prop="code"
              align="center"
              label="代码">
            </el-table-column>
            <el-table-column
              prop="type"
              align="center"
              label="交易方向">
            </el-table-column>
            <el-table-column
              prop="number"
              align="center"
              label="成交数量">
            </el-table-column>
            <el-table-column
              prop="price"
              align="center"
              label="成交价格">
            </el-table-column>
            <el-table-column
              prop="total"
              align="center"
              label="成交金额">
            </el-table-column>
            <el-table-column
              prop="commission"
              align="center"
              label="券商佣金">
            </el-table-column>
            <el-table-column
              prop="stamp"
              align="center"
              label="印花税">
            </el-table-column>
            <el-table-column
              prop="change"
              align="center"
              label="过户费">
            </el-table-column>
            <el-table-column
              prop="time"
              align="center"
              label="成交时间">
              <template slot-scope="scope">
                <p>{{ scope.row.time }}</p>
                <p>{{ scope.row.accurate }}</p>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
    import $ from "jquery";

    export default {
      name: "tradingQuery",
      data(){
        return{
          activeName:'all_depot',
          all_depot:[],
          all_cancel:[],
          entrustData:{
            date:[],
            entrust:[],
            page:1,
            num:20,
          },
          dealData:{
            date:[],
            deal:[],
          },
          unwindData:[],
          totalbuy:0,
          totalsell:0
        }
      },
      methods:{
        getAllDepot() {
          let that = this;
          that.$http({
              url: "/",
              method: "post",
              data: {
                nozzle: 'all_depot',
                token: window.sessionStorage.getItem('token'),
              }
            })
            .then(function(res) {
              let resData = res.data;
              if (resData.code == 1) {
                let dataArr = resData.data;
                if (dataArr.length != 0){
                  let shortArr = [];
                  $.each(dataArr, function(index, item) {
                    shortArr.push(item.short);
                  });
                  that.getNewPrice(shortArr,dataArr);
                }else{
                  that.all_depot = resData.data;
                }
              } else if (resData.code == 0 || resData.code == -1) {
                that.$message.error(res.data.msg);
              }
            });
        },
        getAllCancel(){
          let that = this;
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: 'all_cancel',
              token: window.sessionStorage.getItem('token'),
            }
          })
            .then(function(res) {
              let resData = res.data;
              if (resData.code == 1) {
                that.all_cancel = resData.data;
              } else if (resData.code == 0 || resData.code == -1) {
                that.$message.error(res.data.msg);
              }
            });
        },
        getEntrust(){
          let that = this;
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: 'all_entrust',
              token: window.sessionStorage.getItem('token'),
              start:that.entrustData.date[0],
              end:that.entrustData.date[1],
              page:that.entrustData.page,
              num:that.entrustData.num,
            }
          })
            .then(function(res) {
              let resData = res.data;
              if (resData.code == 1) {
                let entrust = resData.data;
                let unwindData = [];
                for (let i = 0,len = entrust.length;i < len; i++){
                  if (entrust[i].depot_mold === 1){
                    unwindData.push(entrust[i])

                  }
                }
                that.unwindData = unwindData;
                that.entrustData.entrust = entrust;
              } else if (resData.code == 0 || resData.code == -1) {
                that.$message.error(res.data.msg);
              }
            });
        },
        getUnwindData(){
          let that = this;
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: 'all_deal',
              token: window.sessionStorage.getItem('token'),
            }
          })
            .then(function(res) {
              let resData = res.data;
              if (resData.code == 1) {
                let entrust = resData.data;
                let unwindData = [];
                for (let i = 0,len = entrust.length;i < len; i++){
                  if (entrust[i].depot_mold === 1){
                    unwindData.push(entrust[i])
                    that.totalbuy = that.totalbuy + parseFloat(entrust[i].total)
                  }else{
                    that.totalsell = that.totalsell + parseFloat(entrust[i].total)
                  }
                }
                that.unwindData = unwindData;
              } else if (resData.code == 0 || resData.code == -1) {
                that.$message.error(res.data.msg);
              }
            });

        },
        getDeal(){
          let that = this;
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: 'all_deal',
              token: window.sessionStorage.getItem('token'),
              start:that.dealData.date[0],
              end:that.dealData.date[1],
            }
          })
            .then(function(res) {
              let resData = res.data;
              if (resData.code == 1) {
                that.dealData.deal = resData.data;
              } else if (resData.code == 0 || resData.code == -1) {
                that.$message.error(res.data.msg);
              }
            });
        },
        prevEntrust(){
          let page = this.entrustData.page;
          if (page == 1){
            this.$message({
              message: '已经是第一页',
              type: 'warning'
            });
          }else{
            this.entrustData.page = page-1;
            this.getEntrust();
          }
        },
        nextEntrust(){
          let page = this.entrustData.page;
          if ( this.entrustData.entrust.length < 20){
            this.$message({
              message: '已经是最后一页',
              type: 'warning'
            });
          }else{
            this.entrustData.page = page+1;
            this.getEntrust();
          }
        },
        handleDelete(data){
          let that = this;
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "cancel_entrust",
              token: sessionStorage.getItem("token"),
              'cid': data.cid,
              order: data.id
            }
          })
            .then(function(res) {
              if (res.data.code == 1) {
                that.$message({
                  message: res.data.msg,
                  type: "success",
                  duration: 1000,
                  onClose:function () {
                    that.getAllCancel();
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$message.error(res.data.msg);
              }
            });
        },
        getNewPrice(shortArr, dataArr) {
          let that = this;
          $.ajax({
            url: "https://qt.gtimg.cn/q=" + shortArr.toString(),
            type: "GET",
            dataType: "script",
            cache: true,
            success: function() {
              var i, elements;
              for (i = 0; i < shortArr.length; i++) {
                var elements = eval("v_" + shortArr[i]).split("~");
                dataArr[i]["newPrice"] = elements[3]; //当前价
                var newPrice = parseFloat(elements[3]); //当前价
                var number = parseFloat(dataArr[i].number); //持有股数
                var costPrice = parseFloat(dataArr[i].price); //成本价
                var profitPrice = Number((newPrice - costPrice).toFixed(2)); //盈亏金额
                var priceRatio = ((newPrice - costPrice) / costPrice) * 100; //盈亏比例
                var market = (newPrice * number).toFixed(2); //当前市值
                priceRatio = priceRatio.toFixed(2);
                dataArr[i]["profitPrice"] = profitPrice;
                dataArr[i]["priceRatio"] = priceRatio;
                dataArr[i]["market"] = market;
              }
              that.all_depot = dataArr
            }
          });
        },
      },
      mounted(){
        this.getAllDepot();
        this.getAllCancel();
        this.getUnwindData();
        this.getDeal();
        this.getEntrust();
      },

    }
</script>

<style scoped>
  .changePage{
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tradingQuery.vue